import _ from 'lodash';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import PaymentHistoryDetailLine from '../App/Models/PaymentHistoryDetailLine';
import PaymentHistoryPaymentLine_Header from './PaymentHistoryPaymentLine_Header';
import PaymentHistoryPaymentLine_Item from './PaymentHistoryPaymentLine_Item';

interface Props {
  paymentHistoryPaymentLines?: Array<PaymentHistoryDetailLine>;
}

@observer
class PaymentHistoryPayments extends Component<Props> {

  render() {
    let { paymentHistoryPaymentLines } = this.props;

    // Split mixed API rows into settlement/payment summary rows and invoice detail rows.
    let paymentLinesExist = _.filter(paymentHistoryPaymentLines, ['isTotal', true]);
    let invoiceLinesExist = _.filter(paymentHistoryPaymentLines, ['isTotal', false]);

    // Compare sorted amounts to detect when settlement rows are a mirror of invoice rows.
    // In that case, rendering both blocks causes duplicate-looking UI.
    const paymentAmounts = _.sortBy(paymentLinesExist.map((line: PaymentHistoryDetailLine) => line.amount));
    const invoiceAmounts = _.sortBy(invoiceLinesExist.map((line: PaymentHistoryDetailLine) => line.amount));
    const isRedundantMirror =
      paymentAmounts.length > 0
      && paymentAmounts.length === invoiceAmounts.length
      && _.isEqual(paymentAmounts, invoiceAmounts);

    // Hide this section when there is nothing meaningful to show.
    if (!paymentHistoryPaymentLines || paymentLinesExist.length <= 1 || isRedundantMirror) {
      return (<div />);
    }
    return (
      <>
        <div className="c-paymentHistoryDetailLine__div">
          {
            paymentLinesExist.map((detailRow: PaymentHistoryDetailLine) => {
              return (
                <PaymentHistoryPaymentLine_Item key={`${detailRow.killsheetNumber}-${detailRow.referenceNumber}`} detailLine={detailRow} />
              );
            })
          }
          <PaymentHistoryPaymentLine_Header />
        </div>
      </>
    );
  }
}

export default PaymentHistoryPayments;